module.exports = __webpack_public_path__ + "e16.no2.1604e76a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/e16.no2.jpg
// module id = 8p6V
// module chunks = 0